<template>
    <div>
        <v-container fluid class="activity-logs">
            <v-row>
                <v-col>
                    <v-card class="content-card my-4">
                        <v-card-title>
                            <span>Activity Logs</span>
                            <v-spacer></v-spacer>
                            <v-btn color="secondary" outlined @click="loadData()"><v-icon>refresh</v-icon>Refresh</v-btn>
                        </v-card-title>
                        <v-data-table :headers="headers" :items-per-page="1000" :items="activityLogs" :search="search" class="elevation-1">
                            <v-progress-linear color="blue" indeterminate></v-progress-linear>
                            <template v-slot:item="props">
                                <tr>
                                    <td class="text-xs-center">
                                        {{ props.item.id }}
                                    </td>
                                    <td class="text-xs-left">
                                        <strong>{{ props.item.activity_type }}</strong>
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.created_at | formatDateTimeMinutes }}
                                    </td>
                                    <td class="text-xs-left">
                                        <span v-if="props.item.user">
                                            <router-link :to="{ name: 'users.details', params: { id: props.item.user } }" target="_blank">
                                                {{ props.item.user }}
                                            </router-link>
                                        </span>
                                        <span v-else>-</span>
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.uuid }}
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.device }}
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.details }}
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import { UuidsApi } from '@/api';
import { dates } from '@/utils/mixins';

export default {
    name: 'ActivityLogs',
    mixins: [dates],
    data: () => ({
        search: '',
        activityLogs: [],
        headers: [
            {
                text: 'ID',
                align: 'left',
                sortable: true,
                value: 'id',
                width: '8%',
            },
            {
                text: 'Activity Type',
                align: 'left',
                sortable: false,
                value: 'activity_type',
                width: '25%',
            },
            {
                text: 'Datetime',
                align: 'left',
                sortable: false,
                value: 'created_at',
                width: '15%',
            },
            {
                text: 'User',
                align: 'left',
                sortable: false,
                value: 'user',
                width: '7%',
            },
            {
                text: 'UUID',
                align: 'left',
                sortable: false,
                value: 'uuid',
                width: '7%',
            },
            {
                text: 'Device',
                align: 'left',
                sortable: false,
                value: 'device',
                width: '8%',
            },
            {
                text: 'Details',
                align: 'left',
                sortable: true,
                value: 'details',
                width: '30%',
            },
        ],
    }),
    created() {
        this.loadData();
    },
    methods: {
        async loadData() {
            const { data: items } = await UuidsApi.activityLogList({ limit: 200 });
            this.activityLogs = items;
        },
    },
};
</script>

<style lang="scss"></style>
